import Tooltip from "components/Popover";
import useLabels from "hooks/useLabels";
import Tag from "components/Tag";

function RetractedTag() {
  const [tooltipsLabels] = useLabels("tooltips.retracted");

  const tooltipContent = (
    <div className="flex flex-col gap-3 p-3">
      <div className="flex items-center gap-2">
        <i className="icon-triangle-alert text-base text-fg-base" />
        <span className="font-bold text-base text-fg-base">
          {tooltipsLabels["title"]}
        </span>
      </div>
      <p className="text-sm text-fg-base leading-normal text-left">
        {tooltipsLabels["content"]}
      </p>
    </div>
  );

  return (
    <Tooltip
      interactive
      maxWidth={326}
      appendToParent
      className="flex items-center"
      tooltipContent={tooltipContent}
    >
      <Tag
        label={tooltipsLabels["title"]}
        icon="icon-triangle-alert"
        variant="NO"
        data-testid="retracted-paper-tag"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      />
    </Tooltip>
  );
}

export default RetractedTag;
